import { redirectToPage } from "@client/actions";
import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { globals } from "@client/globals";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState, ScreenType } from "@client/types";
import appInfo from "@common/appInfo";
import { init } from "../actions";
import {
  localStateSelector,
  makeKpisSelector,
  makeReportOptionsSelector,
  makeWelcomeSelector,
  makeWidgetStyleSelector
} from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const fieldStyleSelector = makeFieldStyleSelector(TargetSelector.Entity);
  const gapSelector = getSettingValueSelector(TargetSelector.Entity, "gap");
  const kpisSelector = makeKpisSelector();
  const reportOptionsSelector = makeReportOptionsSelector();
  const headingSelector = getSettingValueSelector(TargetSelector.Entity, "heading");
  const welcomeSelector = makeWelcomeSelector();
  const widgetStyleSelector = makeWidgetStyleSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      affiliateDate: appInfo.user?.affiliateDate ?? localState.affiliateDate,
      affiliateLinks: localState.affiliateLinks,
      apiInfo: apiInfoSelector(state, props),
      cycleOptions: localState.cycleOptions,
      heading: headingSelector(state, props),
      fieldStyle: fieldStyleSelector(state, props),
      gap: gapSelector(state, props),
      kpiOptions: kpisSelector(state, props),
      incentives: localState.incentives,
      isMobile: state.viewport.screen === ScreenType.Mobile,
      isEditMode: state.isEditMode,
      offers: localState.offers,
      profilePageId: globals.siteInfo.profilePageId,
      reportOptions: reportOptionsSelector(state, props),
      status: localState.status,
      welcome: welcomeSelector(state, props),
      widgetStyle: widgetStyleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onBackClick: () => {}, //dispatch(back(props)),
  onKpiClick: (id: string) => {}, //dispatch(openModuleSettingsModal(id, true)),
  onReportClick: (id: string) => {}, //dispatch(openModuleSettingsModal(id, true)),
  goToPage: (pageId: string) => dispatch(redirectToPage(pageId)),
  join: () => dispatch(init(props, true))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
